var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('MyLoading'):(_vm.empty)?_c('my-empty-view',{attrs:{"empty-desc":_vm.emptyDesc}}):_c('div',[_vm._t("default",function(){return [_c('div',{staticStyle:{"text-align":"center","padding-top":"20vh"}},[_vm._v("数据内容Slot")])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }